import * as React from 'react';
import { useState } from 'react';

import { TrialFormAu } from 'stile-au/src/components/common/TrialFormAu';

import { ResourceAccessBlock as ResourceAccessBlockLayout } from 'stile-shared/src/components/2024/layout/ResourceAccessBlock/ResourceAccessBlock';
import { CONTACT } from 'stile-shared/src/constants';
import type { StileApiLeadType } from 'stile-shared/src/types/services';

type ResourceAccessBlockType = React.PropsWithChildren<{
  title?: string;
  subtitle?: string;
  image: React.ReactNode;
  id: StileApiLeadType;
  redirectUrl: string;
  description?: string;
  formHeading?: string;
  submitLabel?: string;
}>;

export function ResourceAccessBlock({
  title,
  subtitle,
  image,
  id,
  children,
  redirectUrl,
  description,
  formHeading,
  submitLabel,
}: ResourceAccessBlockType) {
  const [submissionSuccess, setSubmissionSuccess] = useState(false);

  const onSubmissionSuccess = () => {
    if (window) {
      setSubmissionSuccess(true);
      window.open(redirectUrl, '_blank');
    }
  };

  return (
    <ResourceAccessBlockLayout
      title={title}
      subtitle={subtitle}
      image={image}
      formHeading={formHeading}
      formDescription={description}
      submissionSuccess={submissionSuccess}
      formContent={
        <TrialFormAu
          onSubmissionSuccess={onSubmissionSuccess}
          leadType={id}
          submitLabel={submitLabel}
        />
      }
      successContent={
        <p>
          Thank you for completing this form. Email us at{' '}
          <a href={CONTACT.au.email.url}>{CONTACT.au.email.text}</a> if you have any feedback.
        </p>
      }
    >
      {children}
    </ResourceAccessBlockLayout>
  );
}
